import { store } from '@utils/configStore'
import { ambassadorManagementReducer } from './slice'

export const injectAmbassadorManagementStore = () => store.injectReducer('ambassadorManagement', ambassadorManagementReducer)
